import { useProfileSendAction } from 'react-easyrocket';
import { Navigate, useSearchParams } from 'react-router';

/**
 * Компонент, который ответственен за послания запроса на подтверждение email
 * Вставляется в роутер, пример <Route path={ROUTE.ACTION} element={<SendAction />} />
 */

export function SendAction() {
  const [searchParams] = useSearchParams();
  useProfileSendAction({ data: searchParams.get('data') });
  return <Navigate to="/" />;
}
